import { EventEmitter } from 'events';

const eventInstance = new EventEmitter();

export default {
  getEventInstance: () => eventInstance,
};
